const t = "dottedSlider_k00Y-", o = "dottedSlider__controls_9yoBw", d = "dottedArrow_-kLso", r = "dottedArrow__left_DLQAH", e = "dottedArrow__right_xazjI", _ = {
  dottedSlider: t,
  dottedSlider__controls: o,
  dottedArrow: d,
  dottedArrow__left: r,
  dottedArrow__right: e
};
export {
  _ as default,
  d as dottedArrow,
  r as dottedArrow__left,
  e as dottedArrow__right,
  t as dottedSlider,
  o as dottedSlider__controls
};
//# sourceMappingURL=dottedSlider.module.scss.js.map
